import React from "react"
import ReactDOM from "react-dom"

type PortalProps = {
	container?: Element
}

const Portal: React.FC<PortalProps> = (props) => {
	const {
		children,
		container
	} = props

	return (
		<React.Fragment>
			{container && (
				ReactDOM.createPortal(children, container)
			)}
		</React.Fragment>
	)
}

export default Portal
